import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Button(theme: Theme) {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          '&:hover': {
            boxShadow: 'none',
          },
        },
        sizeLarge: {
          height: 42,
        },
        // contained
        containedInherit: {
          color: theme.palette.grey[800],
          boxShadow: theme.customShadows.z8,
          '&:hover': {
            backgroundColor: theme.palette.grey[400],
          },
        },
        containedPrimary: {
          // boxShadow: theme.customShadows.primary,
          boxShadow: 'none',
        },
        containedSecondary: {
          // boxShadow: theme.customShadows.secondary,
          boxShadow: 'none',
        },
        containedInfo: {
          // boxShadow: theme.customShadows.info,
          boxShadow: 'none',
        },
        containedSuccess: {
          // boxShadow: theme.customShadows.success,
          boxShadow: 'none',
        },
        containedWarning: {
          // boxShadow: theme.customShadows.warning,
          boxShadow: 'none',
        },
        containedError: {
          // boxShadow: theme.customShadows.error,
          boxShadow: 'none',
        },
        // outlined
        outlinedInherit: {
          border: `1px solid ${theme.palette.grey[500_32]}`,
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
        },
        textInherit: {
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
        },
      },
    },
  };
}
